import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import xtend from 'xtend';
import QueryString from 'query-string';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import SharedStringGeneratorMixin from './SharedStringGeneratorMixin';
import ClipboardButton from '../../lib/components/form/ClipboardButton';

var EmbedStringGenerator = createReactClass({

    mixins: [
        SharedStringGeneratorMixin
    ],

    getInitialState: function () {
        return {
            widthMode: "%",
            width: "100",
            heightMode: "px",
            height: "720",
            constrain: true,
            border: false,
            dynamic: false
        };
    },

    convertDataToQueryString: function (data) {

        var { domain } = this.props;

        var qs = '?clientID=' + data.clientID + '&';

        if (!!data.simple) qs += 'simple=' + data.simple + '&'

        switch (domain) {
            case 'listing':
                return qs + 'id=' + data.id;
            case 'player':
                return qs + 'eventID=' + this.props.eventID;
            case 'persistent':
                Object.keys(data).map(function (k) {
                    if (typeof data[k] === 'object') {
                        data[k] = JSON.stringify(data[k]);
                    }
                });
                return '?' + QueryString.stringify(data);
        }
    },

    handleInputChange: function (event) {
        var { name, value, checked } = event.target;
        var updates = {};

        switch (name) {
            case 'width':
            case 'height':
                var numregx = /^\d+$/;
                if (!value) value = 0;
                if (numregx.test(value)) updates[name] = value;
                break;

            case 'widthMode':
            case 'heightMode':
                updates[name] = value;
                break;

            case 'constrain':
            case 'border':
            case 'dynamic':
                updates[name] = checked;
                break;
        }

        this.setState(xtend(this.state, updates));
    },

    getSelectorName: function () {
        switch (this.props.domain) {
            case 'listing': return 'invintus-event-listing invintus-event-listing-preference-';
            case 'player': return 'invintus-player';
            case 'persistent': return (this.props.persistentStreamData.selector) ?
                this.props.persistentStreamData.selector : 'media-player';
        }
    },

    render: function () {
        var clientID = (this.props.credentials && this.props.credentials.clientID) ?
            this.props.credentials.clientID : (
                (this.props.clientID) ? this.props.clientID : false
            );

        if (!clientID) {
            console.warn('No Client ID provided in the Embed String generator.');
            return <div/>;
        }

        var data = {
            clientID: clientID
        };

        if (this.props.forceBasic) data.simple = true
        if (this.props.preferenceID) data.id = this.props.preferenceID;
        if (this.props.eventID) data.eventID = this.props.eventID;
        if (this.props.persistentStreamData) data = xtend(data, this.props.persistentStreamData);

        return (this.props.renderMode == 'iframe') ?
            this.renderIframeString(data) :
            this.renderScriptString(data);
    },

    renderConstraintElements: function () {
        var { width, widthMode, height, heightMode } = this.state;
        return " width=\"" + width + widthMode +
            "\" height=\"" + height + heightMode + "\"";
    },

    renderIframeString: function (data) {
        var { domain } = this.props;

        var {
            constrain,
            width,
            height,
            widthMode,
            heightMode,
            border,
            dynamic
        } = this.state;

        var host = this.getHost();
        // console.log('renderIframeString', host);

        var iframeId;

        switch (domain) {
            case 'listing': iframeId = "<iframe id=\"invintus-event-listing-frame\""; break;
            case 'player': iframeId = "<iframe id=\"invintus-player-frame\""; break;
            case 'persistent': iframeId = "<iframe id=\"invintus-persistent-stream-frame\""; break;
        }

        var string = iframeId +
            " src=\"" + host + this.convertDataToQueryString(data) + "\"" +
            (constrain ? this.renderConstraintElements() : '') +
            (!border ? " frameborder=\"0\"" : "") +
            " allowfullscreen"
        + "></iframe>";

        if (dynamic) {

            const frameSelector = (domain == 'listing') ?
                'invintus-event-listing-frame' :
                'invintus-persistent-stream-frame';

            string += "<script type=\"text/javascript\">" +
                "var eventMethod=(window.addEventListener)?'addEventListener':'attachEvent';" +
                "var eventer=window[eventMethod];" +
                "var messageEvent=(eventMethod=='attachEvent')?'onmessage':'message';" +
                "eventer(messageEvent,function(msg){" +
                    // @NOTE We give it some extra room as, even without
                    // CSS/padding set, there remains a hidden overflow
                    "if (typeof msg.data === 'number') {" +
                        "document.getElementById('" + frameSelector + "').height=(msg.data+30);" +
                    "}" +
                "},false);" +
            "</script>";
        }

        return (<div className="constraint-input-group">
            <label>iFrame Embed</label>
            <div className="callout clearfix">
                <div className="col-xs-12">
                    <div className="form-inline">
                        <div className="form-group">
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" name="border" checked={border} onChange={this.handleInputChange}/>
                                    &nbsp;Border
                                </label>
                            </div>
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" name="constrain" checked={constrain} onChange={this.handleInputChange}/>
                                    &nbsp;Constrain
                                </label>
                            </div>
                            <div className="input-group">
                                <span className="input-group-addon"><strong>Width</strong></span>
                                <span className="input-group-addon">
                                    <label className="radio-inline">
                                        <input type="radio" name="widthMode" value="%" onChange={this.handleInputChange} defaultChecked={true}/> %
                                    </label>
                                    <label className="radio-inline">
                                        <input type="radio" name="widthMode" value="px" onChange={this.handleInputChange} defaultChecked={false}/> px
                                    </label>
                                </span>
                                <input className="form-control" value={width} name="width" onChange={this.handleInputChange}/>
                            </div>
                            <div className="input-group">
                                <span className="input-group-addon"><strong>Height</strong></span>
                                    <span className="input-group-addon">
                                        <label className="radio-inline">
                                            <input type="radio" name="heightMode" value="%" onChange={this.handleInputChange} defaultChecked={false}/> %
                                        </label>
                                        <label className="radio-inline">
                                            <input type="radio" name="heightMode" value="px" onChange={this.handleInputChange} defaultChecked={true}/> px
                                        </label>
                                    </span>
                                <input className="form-control" value={height} name="height" onChange={this.handleInputChange}/>
                            </div>
                            <div className="checkbox">
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={this.renderDynamicHeightInfo()}>
                                    <label>
                                        <input type="checkbox" name="dynamic" checked={dynamic} onChange={this.handleInputChange}/>
                                        &nbsp;Dynamic Height
                                    </label>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{position: 'relative'}}>
                <textarea className="form-control" value={string} readOnly/>
                <ClipboardButton
                value={string}
                style={{ position: 'absolute', right: '1em', top: 0 }}
                />
            </div>
        </div>);
    },

    renderDynamicHeightInfo: function () {
        var title = <span><i className="fa fa-exclamation-triangle"/> Notice</span>;
        return (<Popover id="dynamic-height-info-popover" title={title}>
            <p>This may not work in certain curcumstances, including when a Content Management System (CMS) parses out "script" tags.</p>
            <p>If your environment doesn't support "script" tags, you will have to statically set the height in pixels.</p>
        </Popover>);
    },

    renderScriptString: function (data) {
        var { eventID, domain } = this.props;

        var host = this.getHost();

        var string;

        if (domain === 'player') {
            var attrLines = ['data-clientid="' + data.clientID + '"'];
            if (eventID) attrLines.push('data-eventid="' + eventID + '"');
            if (data.id) attrLines.push('data-playerprefid="' + data.id + '"');
            if (data.simple) attrLines.push('data-simple="true"');
            string = '<div class="invintus-player"\n' +
                attrLines.map(function (a) { return '     ' + a }).join('\n') + '>\n' +
                '</div>\n' +
                '<script src="' + host + '"></script>';
        } else if (domain === 'persistent') {
            // Modern SDK embed: plain script tag + Invintus.launch({...}).
            // Replaces the legacy self-injecting loader, drops the `model`
            // rename map, and uses the modern `Invintus` global (was
            // InvintusJwplayer). `encoder` and `isPersistentStream` are consumed
            // directly by the player SDK (hosted-player: resolveInput + /sdk-options),
            // so no `model` map is needed. Mirrors the event Preferences embed.
            var launchData = {
                clientID: data.clientID,
                encoder: data.encoder,
                isPersistentStream: true,
                player: data.player,
                selector: data.selector
            };
            string =
                "<div id=\"" + this.getSelectorName() + "\"></div>\n" +
                "<script src=\"" + host + "\"></script>\n" +
                "<script>\n" +
                "  Invintus.launch(" + JSON.stringify(launchData, null, 2) + ");\n" +
                "</script>";
        } else {
            var selectorName = this.getSelectorName();
            var appName, topString;
            switch (domain) {
                case 'listing':
                    appName = 'InvintusEventListing';
                    topString = "<div id=\"invintus-event-listing\" class=\"" + selectorName + data.id + "\"></div>";
                    break;
            }

            string = topString +
                "<script>" +
                    "!(function(src,cb){" +
                        "var s=document.createElement('script');" +
                        "s.src=src;" +
                        "s.async=true;" +
                        "s.charset='utf-8';" +
                        "if(s.readyState){" +
                            "s.onreadystatechange=function(){" +
                                "if(s.readyState=='loaded'||s.readyState=='complete'){" +
                                    "s.onreadystatechange=null;" +
                                    "cb();" +
                                "}" +
                            "};" +
                        "}else{s.onload=function(){" +
                                "cb();" +
                            "};" +
                        "}" +
                        "document.getElementsByTagName('head')[0].appendChild(s);" +
                    "})('" + host + "',function(){" +
                        appName + ".launch(" + JSON.stringify(data) + ");" +
                    "});" +
                "</script>"
            ;
        }

        var rows = Math.max(string.split('\n').length, 3)
        return (
          <div style={{ position: 'relative' }}>
            <textarea
              className='form-control'
              value={string}
              readOnly
              rows={rows}
              style={{ resize: 'vertical' }}
            />
            <ClipboardButton
              value={string}
              style={{ position: 'absolute', right: '1em', top: 0 }}
            />
          </div>
        )
    }
});

export default EmbedStringGenerator;
